import React from "react";
import { Row, Col, Input, Button, Space, Dropdown, message, Select, Image, Tooltip, Table, DatePicker, Modal, Checkbox, } from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import CompanyAutocomplete from "./CompanyAutocomplete";
import ListTable from "./ListTable";
import withRouter from "../withRouter";
import ParentInvoiceStore from "../store/ParentInvoiceStore";
import NotificationStore from "../store/NotificationStore";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import Excel from "../assets/images/NewDesign/Excel.svg";
import downloadIcon from "../assets/images/NewDesign/Download.svg";
import dayjs from "dayjs";
import { decode as base64_decode } from "base-64";
import Cookies from "js-cookie";
const { RangePicker } = DatePicker;
const { Option } = Select;
class ParentInvoiceDetails extends React.Component {
    constructor(props, context) {
        super(props);
        this.handleTableChange = this.handleTableChange.bind(this);
        this.handleChange = this.handleChange.bind(this);


        this.parentInvoiceStore = new ParentInvoiceStore();
        this.notificationStore = new NotificationStore();
        this.state = {
            loading: false,
            pageSize: 50,
            currentPage: 1,
            openConfirm: false,
            confirmLoading: false,
            companyId: "",
            loadList: 0,
            openParentAddForm: false,
            parentId: "",
            listDataUpdate: false,
            companyFieldHighlight: false,
            searchField: "",
            classId: "",
            openDeleteModal: false,
            modalVisible: false,
            deleteData: {},
            studentsMap: {},   // { parentId: [students] }
            loadingMap: {},    // { parentId: true/false }
            fromDate: dayjs().format("YYYY-MM-DD 00:00:00"),
            toDate: dayjs().format("YYYY-MM-DD 23:59:59"),
            paymentStatus: "",
            selectedColumns: [
                {
                    // title: "Parents Name",
                    title: context.translate("_PARENTS_NAME_"),
                    width: 150,
                    dataIndex: "parentName",
                    key: "parentName",
                    ellipsis: {
                        showTitle: true,
                    },
                    fixed: "left",
                },
                {
                    title: context.translate("_STUDENT_NAME_"),
                    width: 150,
                    dataIndex: "studentName",
                    key: "studentName",
                    ellipsis: {
                        showTitle: true,
                    },
                    fixed: "left",
                },
                {
                    title: context.translate("_INVOICE_DATE_"),
                    width: 150,
                    dataIndex: "invoiceDate",
                    key: "invoiceDate",
                    ellipsis: {
                        showTitle: true,
                    },
                    fixed: "left",
                },
                {
                    title: context.translate("_INVOICE_NO_"),
                    width: 150,
                    dataIndex: "invoice_id",
                    key: "invoice_id",
                    ellipsis: {
                        showTitle: true,
                    },
                    fixed: "left",
                },
                {
                    title: context.translate("_INVOICE_RECIEVED_DATE_"),
                    width: 150,
                    dataIndex: "invoiceRecievedDate",
                    key: "invoiceRecievedDate",
                    ellipsis: {
                        showTitle: true,
                    },
                    fixed: "left",
                },
                {
                    title: context.translate("_INVOICE_FROM_DATE_"),
                    width: 150,
                    dataIndex: "invoicePeriodFrom",
                    key: "invoicePeriodFrom",
                    ellipsis: {
                        showTitle: true,
                    },
                    fixed: "left",
                },
                {
                    title: context.translate("_INVOICE_TO_DATE_"),
                    width: 150,
                    dataIndex: "invoicePeriodTo",
                    key: "invoicePeriodTo",
                    ellipsis: {
                        showTitle: true,
                    },
                    fixed: "left",
                },
                {
                    title: context.translate("_INVOICE_AMOUNT_"),
                    width: 150,
                    dataIndex: "invoiceAmount",
                    key: "invoiceAmount",
                    ellipsis: {
                        showTitle: true,
                    },
                    fixed: "left",
                },
                {
                    title: context.translate("_PAYMENT_STATUS_"),
                    width: 150,
                    dataIndex: "paymentStatus",
                    key: "paymentStatus",
                    ellipsis: {
                        showTitle: true,
                    },
                    fixed: "left",
                },


            ]
        };



        this.ExportMenuProps = {
            items: [
                {
                    label: (
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                            }}
                        >
                            {" "}
                            <Image
                                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                                src={Excel}
                            ></Image>
                            {context.translate("_EXPORT_AS_EXCEL_")}
                        </div>
                    ),
                    key: "excel",
                }

            ],
            onClick: (val) => {
                let result = [];
                if (true) {
                    this.state.selectedColumns.map((obj) => result.push(obj.dataIndex));
                    var getData = {
                        companyId: this.state.companyId,
                        colList: result.toString(),
                        fromDate: this.state.fromDate,
                        userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
                        toDate: this.state.toDate,
                        paymentStatus: this.state.paymentStatus
                    };
                    if (val.key === "excel") {
                        this.parentInvoiceStore.exportExcel(getData);
                    }

                }
            },
        };
        this.newColumns = [...this.state.selectedColumns];
    }

    async componentDidUpdate(prevProps, prevState) {
        if (prevState.listDataUpdate !== this.state.listDataUpdate) {
            await this.handleSearch();
        }
    }
    async componentDidMount() {
        if (
            Number(this.props.getUserData().isadmin) !== -1 &&
            Number(this.props.getUserData().isadmin) !== 3
        ) {
            await this.setState({
                companyId: this.props.getUserData().userCompanyId,
            });
            await this.setState({ userId: this.props.getUserData().userId });
            await this.handleSearch();
        }
        this.setState({ pageSize: 50, column: this.state.selectedColumns });


    }
    handleCheckboxChange = async (column) => {
        console.log(column);
        if (this.state.selectedColumns.some((c) => c.key === column.key)) {
            const filtered = this.state.selectedColumns.filter(
                (c) => c.key !== column.key
            );
            console.log(filtered);
            await this.setState({
                selectedColumns: filtered,
            });
            await this.setState({ column: filtered });
            // await  this.updateVisibleColumns();
        } else {
            console.log("adsf");
            await this.setState({
                selectedColumns: [...this.state.selectedColumns, column],
                column: [...this.state.selectedColumns, column],
            });
            // await  this.updateVisibleColumns();
        }
    };
    async showData() {
        await this.handleSearch();
    }
    async handleTableChange(pagination) {
        await this.setState({
            currentPage: pagination.current,
            pageSize: pagination.pageSize,
        });
        this.handleSearch();
    }

    async handleChange(comp) {
        await this.setState({
            companyId: comp.value,
            searchField: "",
            classId: "",
        });
        console.log(comp);
        await this.handleSearch();
    }

    async handleSearch() {
        this.setState({ loading: true });
        await this.parentInvoiceStore.loadData({
            offset: (this.state.currentPage - 1) * this.state.pageSize,
            limit: this.state.pageSize,
            searchField: this.state.searchField,
            companyId: this.state.companyId,
            paymentStatus: this.state.paymentStatus,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate
        });
        await this.setState({ loadList: 1 });
    }

    refreshList = async () => {
        if (this.state.companyId) {

            await this.parentInvoiceStore.loadData({
                offset: 0,
                limit: 50,
                companyId: this.state.companyId,
                searchField: "",
                paymentStatus: this.state.paymentStatus,
                fromDate: this.state.fromDate,
                toDate: this.state.toDate
            });
            this.setState({
                loading: false,
                currentPage: 1,
                searchField: "",
                classId: "",
            });
        }
    };
    onDateTimeChange = (dates) => {
        if (dates) {
            const format = "YYYY-MM-DD HH:mm:ss";
            this.setState({
                fromDate: dates[0]?.format(format),
                toDate: dates[1]?.format(format),
            });
        } else {
            this.setState({ fromDate: "", toDate: "" });
        }
    };


    render() {
        const companyInputBox = this.state.companyFieldHighlight
            ? { border: "2px solid red", width: "150px", borderRadius: "8px" }
            : { width: "150px" };
        return (
            <>
                <div className="listHeader">
                    <Row className="listInputRow">
                        <Col span={16}>
                            <Space>
                                <CompanyAutocomplete
                                    className="searchInput"
                                    onChange={this.handleChange}
                                    style={companyInputBox}
                                />
                                <RangePicker
                                    showNow={false}
                                    placeholder={["From Datetime", "To Datetime"]}
                                    format="DD-MM-YYYY hh:mmA"
                                    style={{ width: 400, borderRadius: "25px" }}
                                    onChange={(val) => {
                                        this.onDateTimeChange(val);
                                    }}

                                    showTime={{
                                        format: "h:mmA",
                                        defaultValue: [
                                            dayjs().startOf("day"),
                                            dayjs().endOf("day"),
                                        ],
                                    }}
                                    status={this.state.Notdate ? "error" : false}
                                    defaultValue={[dayjs().startOf("day"), dayjs().endOf("day")]}

                                />
                                <Select
                                    className="searchInput"
                                    style={{ width: 150 }}
                                    // value={this.state.paymentStatus ? this.state.subscribe : 0}
                                    placeholder={this.context.translate("_PAYMENT_STATUS_")}
                                    onChange={async (val) => {
                                        await this.setState({ paymentStatus: val });
                                        // await this.handleSearch();
                                    }}
                                >
                                    <Select.Option value={0}>
                                        {this.context.translate(
                                            "_ALL_"
                                        )}
                                    </Select.Option>
                                    <Select.Option value={1}>
                                        {this.context.translate(
                                            "_PAID_"
                                        )}
                                    </Select.Option>

                                    <Select.Option value={2}>
                                        {this.context.translate(
                                            "_UNPAID_"
                                        )}
                                    </Select.Option>
                                </Select>
                                <Button
                                    type="primary"
                                    onClick={() => {
                                        this.showData();
                                        this.setState({ currentPage: 1 });
                                    }}
                                >
                                    {/* Show */}
                                    {this.context.translate("_FLEET_SHOW_BTN_")}
                                </Button>
                                <Button onClick={() => this.setState({ modalVisible: true })}>
                                    {this.context.translate("_COLUMNS_")}
                                </Button>
                            </Space>
                        </Col>
                        <Col
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "end",
                            }}
                            span={4}
                        >
                            <Space>
                                <Tooltip
                                    title={this.context.translate("_REFRESH_")}
                                    placement="bottom"
                                >
                                    <Image
                                        style={{
                                            height: 18,
                                            // marginInlineEnd: "20px",
                                            alignItems: "center",
                                            cursor: "pointer",
                                        }}
                                        src={refreshIcon}
                                        onClick={() => this.refreshList()}
                                    ></Image>
                                </Tooltip>
                                <Button
                                    className="downloadExcelButton"
                                    disabled={
                                        this.parentInvoiceStore?.invoiceDetails?.length > 0 ? false : true
                                    }
                                >
                                    <Dropdown
                                        overlayClassName="export-dropdown"
                                        menu={this.ExportMenuProps}
                                    >
                                        <Image
                                            style={{
                                                height: 18,
                                                alignItems: "center",
                                                marginInlineEnd: "30px",
                                            }}
                                            src={downloadIcon}
                                        ></Image>
                                    </Dropdown>
                                </Button>
                            </Space>
                        </Col>
                    </Row>
                    <Modal
                        open={this.state.modalVisible}
                        width={300}
                        // title="Select Columns"
                        title={this.context.translate("_SELECT_COLUMNS_")}
                        onCancel={() => this.setState({ modalVisible: false })}
                        onOk={() => {
                            this.setState({ modalVisible: false });
                        }}
                        footer={null}
                    >
                        <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                            {console.log(this.newColumns, "Df")}
                            {this.newColumns.map((column, v) => {
                                return (
                                    <Row key={v}>
                                        <Col>
                                            <Checkbox
                                                onChange={() => this.handleCheckboxChange(column)}
                                                checked={this.state.selectedColumns.some(
                                                    (c) => c.key === column.key
                                                )}
                                            >
                                                {column.title}
                                            </Checkbox>
                                        </Col>
                                    </Row>
                                );
                            })}
                        </div>
                    </Modal>
                    <ListTable
                        current={this.state.currentPage}
                        total={this.parentInvoiceStore?.total}
                        columns={this.state.column}
                        dataSource={this.parentInvoiceStore?.invoiceDetails}
                        loading={this.parentInvoiceStore?.loading}
                        onChange={this.handleTableChange}
                        rowKey="invoiceId"
                    />
                </div>


            </>
        );
    }
}
ParentInvoiceDetails.contextType = StoreContext;
export default observer(withRouter(ParentInvoiceDetails));
